import React from "react"
import FlexBox from "@/components/layout/FlexBox"
import {Hint} from "@/components/hint/Hint"
import StickyButtonContainer from "@/pages/mobile/income/components/layout/containers/StickyButtonContainer"

const Style = {
  message: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.6,
    margin: 0,
    textAlign: 'left',
    whiteSpace: 'pre-line',
    opacity: 0.9
  },
}

export const ErrorPage = ({
                            message,
                            onRetry,
                            useManualCapture,
                            onSwitchCaptureMode,
                            hintMessage,
                            hintIcon,
                          }) => {
  return (
    <FlexBox marginTop column>
      {message && (
        <div style={Style.message}>
          {message}
        </div>
      )}
      {hintMessage && (
        <Hint
          message={hintMessage}
          icon={hintIcon}
        />
      )}
      {onRetry && (
        <StickyButtonContainer
          buttons={[
            {
              text: 'Try again',
              onClick: onRetry
            },
            ...(onSwitchCaptureMode ? [{
              text: `Switch to ${useManualCapture ? 'auto' : 'manual'} capture`,
              onClick: onSwitchCaptureMode,
              secondary: true
            }] : [])
          ]}
        />
      )}
    </FlexBox>
  )
}